import { render, staticRenderFns } from "./studentInfo.vue?vue&type=template&id=723c97ac&scoped=true"
import script from "./studentInfo.vue?vue&type=script&lang=js"
export * from "./studentInfo.vue?vue&type=script&lang=js"
import style0 from "./studentInfo.vue?vue&type=style&index=0&id=723c97ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723c97ac",
  null
  
)

export default component.exports